import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import { pdfjs } from 'react-pdf';

import 'normalize.css';
import 'virtues-bootstrap/dist/main.css';
import 'text-security/dist/text-security-disc.min.css';

import createStore from './store';
import history from './history';
import App from './App';
import i18n from './services/i18n';
import googleAnalyticsInit from './services/googleAnalytics';

import './index.scss';

googleAnalyticsInit(history);

const store = createStore({}, history);

// sticky hover fix in iOS
// from: http://fofwebdesign.co.uk/template/_testing/ios-sticky-hover-fix.htm
document.addEventListener('touchend', () => {});

const render = Component => {
  ReactDOM.render(
    <I18nextProvider i18n={i18n}>
      <Provider store={store}>
        <Component history={history} />
      </Provider>
    </I18nextProvider>,
    document.getElementById('root'),
  );
};

render(App);

if (module.hot) {
  module.hot.accept('./App', () => {
    // eslint-disable-next-line global-require
    const NextApp = require('./App').default;
    render(NextApp);
  });
}

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
